/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedBlurbLeadTime_sku = {
    readonly leadTime: string | null;
    readonly " $refType": "PdpSharedBlurbLeadTime_sku";
};
export type PdpSharedBlurbLeadTime_sku$data = PdpSharedBlurbLeadTime_sku;
export type PdpSharedBlurbLeadTime_sku$key = {
    readonly " $data"?: PdpSharedBlurbLeadTime_sku$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbLeadTime_sku">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbLeadTime_sku",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "pageType",
          "value": "PDP"
        }
      ],
      "kind": "ScalarField",
      "name": "leadTime",
      "storageKey": "leadTime(pageType:\"PDP\")"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};
(node as any).hash = 'c8b51bfbda45470417e53311fb8cf290';
export default node;
